export default __webpack_public_path__ + "e1742372f91f90a619828406de5e32bd.webp";